import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from "@/components/ui/dropdown-menu";
import { ChevronDown } from "lucide-react";

type MenuButtonProps = {
  label: string;
  options: string[];
  onSelect?: (option: string) => void;
};

export function MenuButton({ label, options, onSelect }: MenuButtonProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        render={
          <Button
            type="button"
            variant="default"
            className="group relative w-full justify-between px-4 md:w-2xs md:justify-center"
          >
            <span className="md:text-center">{label}</span>

            <ChevronDown
              size={16}
              className="transition-transform duration-200 ease-in-out group-data-popup-open:rotate-180 md:absolute md:right-4"
            />
          </Button>
        }
      />
      <DropdownMenuContent className="p-2.5 rounded-2xl w-(--anchor-width) shadow-xl">
        {options.map((option) => (
          <DropdownMenuItem
            key={option}
            onClick={() => onSelect?.(option)}
            className="px-3 py-2 rounded-lg text-sm font-medium text-secondary-foreground hover:bg-primary-soft!"
          >
            {option}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
